import { useState } from 'react'

import './css/showQuestion.css'
import Popups from '../../components/Popups'
import Question from './components/question'
import { TbBorderRadius } from 'react-icons/tb'

export default function showQuestion({ data, setOpen }) {
    return (
        <Popups index={18} setOpen={setOpen} style={{maxWidth:600, backgroundColor:"#f1f1f1", borderRadius:10}}>
            <Question showAnswers={true} show={true} k={0} data={data} />
        </Popups>
    )
}
